export const GET_ALL_USERS_API = "tickets/ticket/all-users";

export const GET_ALL_USERS = {
  GET_ALL_USERS_LOAD: "GET_ALL_USERS_LOAD",
  GET_ALL_USERS_SUCCESS: "GET_ALL_USERS_SUCCESS",
  GET_ALL_USERS_FAIL: "GET_ALL_USERS_FAIL",
};


export const CREATE_TICKET_API = "tickets/ticket";

export const CREATE_TICKET = {
  CREATE_TICKET_LOAD: "CREATE_TICKET_LOAD",
  CREATE_TICKET_SUCCESS: "CREATE_TICKET_SUCCESS",
  CREATE_TICKET_FAIL: "CREATE_TICKET_FAIL",
  CREATE_TICKET_RESET: "CREATE_TICKET_RESET",
};
